import { formatMoneyParts, type Money, type MoneyPart } from '../../format/format.ts';
import styles from './MoneyText.module.css';

export type MoneyTextProps = { money: Money; locale: string; upTo?: Money | undefined };

const RANGE_SEPARATOR = ' – ';

const figuresOf = (parts: readonly MoneyPart[]): string =>
  parts
    .filter((part) => part.kind === 'figure')
    .map((part) => part.text)
    .join('')
    .trim();

const currencyFirst = (parts: readonly MoneyPart[]): boolean =>
  parts.findIndex((part) => part.kind === 'currency') < parts.findIndex((part) => part.kind === 'figure');

const Range = ({ money, upTo, locale }: { money: Money; upTo: Money; locale: string }) => {
  const parts = formatMoneyParts(money, locale);
  const currency = <span className={styles['currency']}>{money.currency}</span>;
  const figures = `${figuresOf(parts)}${RANGE_SEPARATOR}${figuresOf(formatMoneyParts(upTo, locale))}`;
  return currencyFirst(parts) ? (
    <span className={styles['money']}>
      {currency} {figures}
    </span>
  ) : (
    <span className={styles['money']}>
      {figures} {currency}
    </span>
  );
};

export const MoneyText = ({ money, locale, upTo }: MoneyTextProps) =>
  upTo === undefined ? (
    <span className={styles['money']}>
      {formatMoneyParts(money, locale).map((part, index) =>
        part.kind === 'currency' ? (
          <span key={index} className={styles['currency']}>
            {part.text}
          </span>
        ) : (
          part.text
        ),
      )}
    </span>
  ) : (
    <Range money={money} upTo={upTo} locale={locale} />
  );
